export default "<div class=\"loading\" [class.inherit-size]=\"inheritSize\">\n  <img src=\"/assets/img/loading.gif\" alt=\"\">\n</div>\n"